import { API_URL } from "./config";
import axios from "axios";

const FEEDBACK_URL = `${API_URL}/feedback`;
export type TFeedbackDetails  = {
  analysis_id: string;
  asset_id: string | null;
  content: string;
  created_at: string;
  id: string;
  reaction: "positive" | "negative";
  response_id: string | null;
  tags: string | null;
  updated_at: string;
  user_id: number;
  view: string | null;
};
export type TEntityTypes = "asset_id" | "analysis_id" | "response_id" | undefined;
export type saveFeedbackPropTypes = {
  view?: string;
  content?: string;
  reaction?: "positive" | "negative" | null;
  tags?: string;
  asset_id?: string;
  analysis_id?: string;
  response_id?: string;
  id?: string;
};
export const saveFeedback = async (feedback: saveFeedbackPropTypes): Promise<any> => {
  const payload: Record<string, any> = {
    view: feedback.view,
    content: feedback.content,
    ...(feedback.reaction && { reaction: feedback.reaction }),
    ...(feedback.asset_id && { asset_id: feedback.asset_id }),
    ...(feedback.analysis_id && { analysis_id: feedback.analysis_id }),
    ...(feedback.response_id && { response_id: feedback.response_id }),
    ...(feedback.reaction === "negative" && feedback.tags && { tags: feedback.tags }),
    ...(feedback.id && { id: feedback.id }),
  };

  if (feedback.reaction === "positive") {
    payload.tags = null;
  }

    let response;
    if (feedback.id) {
      response = await axios.patch(`${FEEDBACK_URL}/${feedback.id}`, payload);
    } else {
      response = await axios.post(`${FEEDBACK_URL}/create`, payload);
    }
    return response.data;
};